import { Callback } from "@/types/types";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import Template from "./Timeclock.template.vue";

@Component({
  mixins: [Template]
})
export default class TimeclockComponent extends Vue {
  @Action("changeTitle", { namespace: "MegaMenuModule" })
  public changeTitleAction!: Callback;
  @Action("changeSubTitle", { namespace: "MegaMenuModule" })
  public changeSubTitleAction!: Callback;
  @Action("changeIcon", { namespace: "MegaMenuModule" })
  public changeIcon!: Callback;
  constructor() {
    super();
    this.changeIcon(
      require("@/assets/images/icon_primary_menu_dashboard@2x.png")
    );
    this.changeTitleAction("Dashboard");
    this.changeSubTitleAction("");
  }
}
